import { Grid, Stack, Typography } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { useState } from 'react';
import { useParams } from 'react-router-dom'
import { fetchDataFromApi } from '../../utils/api';
import { Context } from '../../utils/context';

const OrderDetail = () => {
    const { id } = useParams();
    const { orderDetailItem } = useContext(Context)

    const [loading, setLoading] = useState(false)
    const [orderDetails, setOrderDetails] = useState({})
    useEffect(() => {
        setLoading(true)
        fetchDataFromApi("/orders/get-single-order/" + id)
            .then((res) => setOrderDetails(res?.data))
            .catch((error) => console.log(error))
            .finally(() => setLoading(false))
    }, [id])
    const otherProducts = orderDetails?.products?.filter((el) => el._id !== orderDetailItem)
    const data = orderDetails?.products?.find((el) => el._id === orderDetailItem)
    return (
        <Grid Grid container spacing={2} justifyContent={"Center"} alignItems="center" >
            <Grid item xs={11} sm={10} md={8} >
                <Typography fontSize={"22px"} my="10px" fontWeight={"600"} color="green" >OrderID : {id}</Typography>
                <Typography fontSize={"14px"} mt="10px" fontWeight={"600"}>Ordered on : {new Date(orderDetails?.createdAt).toLocaleString()}</Typography>
                <Typography fontSize={"14px"} mb="10px" fontWeight={"600"}>Delivery Status  : {orderDetails?.delivery_status}</Typography>
                <Stack border={"1px solid #ddd"} my="15px" padding="15px" className='rounded'>
                    <Typography fontSize={"14px"} my="2px" fontWeight={"600"}>Delivery Address</Typography>
                    <Typography fontSize={"14px"} my="2px" fontWeight={"600"}>{orderDetails?.shipping_address?.name}</Typography>
                    <Typography fontSize={"14px"} mt="2px" >{orderDetails?.shipping_address?.address}, {orderDetails?.shipping_address?.locality}</Typography>
                    <Typography fontSize={"14px"} mb="2px" >{orderDetails?.shipping_address?.city}, {orderDetails?.shipping_address?.state}, Pincode:- {orderDetails?.shipping_address?.pincode}</Typography>
                    <Typography fontSize={"14px"} my="2px" fontWeight={"600"}>Phone Number</Typography>
                    <Typography fontSize={"14px"} my="2px" >{orderDetails?.shipping_address?.mobile}</Typography>
                </Stack>
                <Stack border={"1px solid #ddd"} my="15px" padding="15px" className='rounded'>
                    <Stack>
                        <Typography fontSize={"14px"} my="2px" fontWeight={"600"}>₹ {orderDetails?.total} | {orderDetails?.payment_status}</Typography>
                    </Stack>
                    <Typography fontSize={"14px"} my="2px" fontWeight={"600"}>by {orderDetails?.payment_mode}</Typography>
                </Stack>
                <Stack border={"1px solid #ddd"} my="15px" padding="15px" className='rounded'>
                    <Typography fontSize={"14px"} my="2px" fontWeight={"600"}>Item :</Typography>
                    <SingleItem data={data} />
                </Stack>
                <Stack border={"1px solid #ddd"} my="15px" padding="15px" className='rounded'>
                    <Typography fontSize={"14px"} my="2px" fontWeight={"600"}>Other Items in this order :</Typography>
                    {
                        otherProducts?.map((item) => {
                            return <SingleItem data={item} />
                        })
                    }
                </Stack>
            </Grid>
        </Grid>
    )
}

export default OrderDetail

const SingleItem = ({ data }) => {
    const getDiscount = (price, originalPrice) => {
        const value = parseInt((price * 100) / originalPrice);
        return Math.abs(Math.abs(value - 100));
    };
    return (
        <Stack className='rounded' direction={"row"} border={"1px solid #ddd"} padding="15px" gap="15px" my="5px">
            <Stack sx={{ width: "15%" }}>
                <img className="rounded object-fit-cover" style={{ maxHeight: "150px" }} alt={data?.images?.featuredImage?.alt} src={data?.images?.featuredImage?.src} />
            </Stack>
            <Stack sx={{ display: "flex", flexDirection: "column", gap: "5px", width: "40%" }}>
                <p style={{ fontWeight: 600, fontSize: "15px" }}>{data?.name}</p>
                {!!(data?.productType == "WithBoth") || (data?.productType == "WithColor") ?
                    <Stack direction="row" gap="8px" justifyContent={"flex-start"} alignItems="center">
                        <p style={{ fontWeight: 600, fontSize: "15px" }}>Color</p>
                        <div
                            style={{ backgroundColor: `${data?.color}` }}
                            className={`h-4 w-4 rounded-full shadow-black `}
                        ></div>
                    </Stack>
                    :
                    ""
                }
                {!!(data?.productType == "WithBoth") || (data?.productType == "WithSize") ?
                    <Stack direction="row" gap="8px">
                        <p style={{ fontWeight: 600, fontSize: "15px" }}>Size : </p>
                        <p style={{ fontWeight: 600, fontSize: "15px" }}>{data?.size}</p>
                    </Stack>
                    :
                    ""
                }
                <p style={{ fontWeight: 600, fontSize: "15px" }}>Quantity : {data?.quantity}</p>
            </Stack>
            <Stack sx={{ width: "30%" }}>
                <p style={{ fontWeight: 600, fontSize: "15px" }}>₹ {data?.originalPrice}</p>
                <p style={{ fontWeight: 600, fontSize: "15px", textDecoration: "line-through" }}>₹ {data?.price} <span style={{ color: "green", textDecoration: "" }}>&nbsp; % {getDiscount(data?.price, data?.originalPrice)}</span></p>
                <p style={{ fontWeight: 600, fontSize: "15px" }}>{data?.ordersData?.payment_mode}</p>
            </Stack>
            {/* <Stack sx={{ width: "25%" }}>
                <p style={{ fontWeight: 600, fontSize: "15px" }}>Ordered On {new Date(data?.ordersData?.createdAt).toLocaleDateString()}</p>
                <p style={{ fontWeight: 600, fontSize: "15px", color: "blue" }}> {data?.ordersData?.delivery_status}</p>
            </Stack> */}
        </Stack >
    )
}